/* eslint-disable react/jsx-no-bind */
import { Settings } from '@mui/icons-material';
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem as DropdownItem,
  Paper,
  IconButton,
  Menu,
  CardContent,
  Card,
  TablePagination,
  Modal,
  Typography,
  useTheme,
  Divider,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { tokens } from '../../theme';
import { formatToIST } from '../../utils/dateFormatter';
import logger from '../../utils/logger';

import parcelDimensionsService from './parcelDimensionsService';

// const initialData = [
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Tata Motors",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Mahindra & Mahindra",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Toyota",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Skoda",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
//   {
//     dimension_name: "Maruti Suzuki",
//     dimension_icon: "maruti_suzuki_icon",
//   },
// ];

const ParcelDimensions = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [errors, setErrors] = useState({
    dimension_name: '',
    dimension_icon: '',
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [newParcelDimension, setNewParcelDimension] = useState({
    dimension_name: '',
    dimension_icon: '',
  });
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [selectedParcelDimension, setSelectedParcelDimension] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fetchParcelDimensions = async () => {
    try {
      const response = await parcelDimensionsService.fetchParcelDimensions();
      const result = response.data.data || [];
      setData(result);
      setOriginalData(result);
    } catch (error) {
      logger.error('Error fetching parcel dimensions:', error);
      toast.error(
        error.response?.data?.message || 'Error fetching parcel dimensions',
      );
    }
  };

  useEffect(() => {
    fetchParcelDimensions();
  }, []);

  const handleSearch = () => {
    const filteredData = originalData.filter(
      (item) =>
        search === '' ||
        item.dimension_name.toLowerCase().includes(search.toLowerCase()),
    );
    setData(filteredData);
  };

  const handleReset = () => {
    setSearch('');
    setData(originalData);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setSelectedParcelDimension(row);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleModalOpen = (editMode = false) => {
    setIsEditMode(editMode);
    if (editMode && selectedParcelDimension) {
      setNewParcelDimension(selectedParcelDimension);
    } else {
      setNewParcelDimension({
        dimension_name: '',
        dimension_icon: '',
      });
    }
    setModalOpen(true);
  };

  const validateInputs = () => {
    let valid = true;
    const newErrors = { dimension_name: '', dimension_icon: '' };

    if (!newParcelDimension.dimension_name.trim()) {
      newErrors.dimension_name = 'Name is required.';
      valid = false;
    }
    if (newParcelDimension.dimension_name.trim().length < 3) {
      newErrors.dimension_name = 'Minimum length must be 3';
      valid = false;
    }
    if (newParcelDimension.dimension_icon.trim().length < 3) {
      newErrors.dimension_icon = 'Minimum length must be 3';
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setNewParcelDimension({
      dimension_name: '',
      dimension_icon: '',
    });
    setErrors({ dimension_name: '', dimension_icon: '' });
    setSelectedParcelDimension(null);
  };

  const handleAddParcelDimension = async () => {
    if (validateInputs()) {
      try {
        await parcelDimensionsService.addParcelDimension(newParcelDimension);
        toast.success('Parcel dimension added successfully!');
        fetchParcelDimensions();
        handleModalClose();
      } catch (error) {
        logger.error('Error adding parcel dimensions:', error);
        toast.error(
          error.response?.data?.message || 'Error adding parcel dimension',
        );
      }
    }
  };

  const handleEditParcelDimension = async () => {
    if (validateInputs()) {
      try {
        await parcelDimensionsService.updateParcelDimension(
          selectedParcelDimension.id,
          newParcelDimension,
        );
        toast.success('Parcel dimension updated successfully!');
        fetchParcelDimensions();
        handleModalClose();
      } catch (error) {
        logger.error('Error editing parcel dimensions:', error);
        toast.error(
          error.response?.data?.message || 'Error updating parcel dimension',
        );
      }
    }
  };

  const handleDelete = async () => {
    try {
      await parcelDimensionsService.deleteParcelDimension(
        selectedParcelDimension.id,
      );
      toast.success(
        `Parcel dimension ID ${selectedParcelDimension.id} deleted successfully.`,
      );
      fetchParcelDimensions();
      handleMenuClose();
    } catch (error) {
      logger.error('Error deleting parcel dimensions', error);
      toast.error(
        error.response?.data?.message || 'Error deleting parcel dimension',
      );
    }
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <h3>Parcel Dimensions</h3>
          </Box>
          <Divider />
          <Box sx={{ padding: 4 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', gap: 2, marginBottom: 3 }}>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        color: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'gray',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: colors.swiftcarry[100],
                    },
                    minWidth: 150,
                  }}
                />

                <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    sx={{
                      bgcolor: colors.swiftcarry[100],
                      '&:hover': {
                        bgcolor: colors.swiftcarry[100],
                      },
                    }}
                  >
                    Search
                  </Button>
                </Box>
                <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    sx={{
                      borderColor: colors.swiftcarry[100],
                      color: colors.swiftcarry[100],
                      '&:hover': {
                        borderColor: colors.swiftcarry[100],
                      },
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Box>
              <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleModalOpen(false)}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                    },
                  }}
                >
                  Add
                </Button>
              </Box>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Dimension Name
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Dimension Icon
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Created On
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Created By
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.dimension_name}</TableCell>
                        <TableCell>{row.dimension_icon}</TableCell>
                        <TableCell>
                          {formatToIST(row.created_on || row.createdOn)}
                        </TableCell>
                        <TableCell>{row.created_by}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={(event) => handleMenuOpen(event, row)}
                          >
                            <Settings />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiToolbar-root': {
                  display: 'flex',
                  width: '500px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-actions': {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                },
                '& .MuiTablePagination-input': {
                  minWidth: '30px',
                },
              }}
            />
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              <DropdownItem
                onClick={() => {
                  handleModalOpen(true);
                  handleMenuClose();
                }}
              >
                Edit
              </DropdownItem>
              <DropdownItem onClick={handleDelete}>Delete</DropdownItem>
            </Menu>
          </Box>
        </CardContent>
      </Card>

      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            {isEditMode ? 'Edit Parcel Dimension' : 'Add Parcel Dimension'}
          </Typography>
          <TextField
            label="Dimension Name"
            variant="outlined"
            fullWidth
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: colors.swiftcarry[100],
                  color: colors.swiftcarry[100],
                },
              },
              '& .MuiInputLabel-root': {
                color: 'gray',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: colors.swiftcarry[100],
              },
              mb: 2,
            }}
            value={newParcelDimension.dimension_name}
            onChange={(e) => {
              setNewParcelDimension({
                ...newParcelDimension,
                dimension_name: e.target.value,
              });
              setErrors({ ...errors, dimension_name: '' });
            }}
            error={!!errors.dimension_name}
            helperText={errors.dimension_name}
          />
          <TextField
            label="Dimension Icon"
            variant="outlined"
            fullWidth
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: colors.swiftcarry[100],
                  color: colors.swiftcarry[100],
                },
              },
              '& .MuiInputLabel-root': {
                color: 'gray',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: colors.swiftcarry[100],
              },
              mb: 2,
            }}
            value={newParcelDimension.dimension_icon}
            onChange={(e) => {
              setNewParcelDimension({
                ...newParcelDimension,
                dimension_icon: e.target.value,
              });
              setErrors({ ...errors, dimension_icon: '' });
            }}
            error={!!errors.dimension_icon}
            helperText={errors.dimension_icon}
          />

          <Box sx={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              onClick={
                isEditMode
                  ? handleEditParcelDimension
                  : handleAddParcelDimension
              }
              disabled={
                !newParcelDimension.dimension_name ||
                !newParcelDimension.dimension_icon
              }
              sx={{
                bgcolor: colors.swiftcarry[100],
                '&:hover': {
                  bgcolor: colors.swiftcarry[100],
                },
              }}
            >
              {isEditMode ? 'Save Changes' : 'Add'}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ParcelDimensions;
